/**
 * Email allow-list for mock LLM access. Single source of truth shared by
 * the server gate (mock-model.ts) and the client picker (ModelSelector.tsx)
 * so adding/removing a domain requires only one edit.
 *
 * Kept in its own module — no `ai/test` or other server-only imports —
 * so the client bundle can pull it in without dragging the mock model.
 */

export const MOCK_EMAIL_SUFFIXES = [
  '@papan.ai',
  '@papan.local',
  '@demo.local',
] as const

/**
 * True if the email's suffix matches the allow-list. Case-insensitive.
 * Empty/missing emails fail.
 */
export function isMockEligibleEmail(email: string | undefined | null): boolean {
  if (!email) return false
  const e = email.toLowerCase()
  return MOCK_EMAIL_SUFFIXES.some(suffix => e.endsWith(suffix))
}
